/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Template_Category_TasksInputs */

const cs_automation_template_category_tasks = /** @type {(inputs: Automation_Template_Category_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úkoly`)
};

const en_automation_template_category_tasks = /** @type {(inputs: Automation_Template_Category_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasks`)
};

/**
* | output |
* | --- |
* | "Tasks" |
*
* @param {Automation_Template_Category_TasksInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_template_category_tasks = /** @type {((inputs?: Automation_Template_Category_TasksInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Template_Category_TasksInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_template_category_tasks(inputs)
	return cs_automation_template_category_tasks(inputs)
});